import React from 'react';
import Slider from 'react-slick';
import './Carousel.css'; // Custom CSS for carousel styling
import logo from './images/floortiles/LivingRoom/image.png'; // Replace with actual images
import logo1 from './images/walltiles/LivingRoomTiles/image.png'; 
import logo2 from './images/carousel/pexels-jvdm-1457847.jpg'; 
import logo3 from './images/carousel/pexels-jworks1124-342800.jpg'; 
import logo4 from './images/carousel/pexels-pixabay-280232.jpg'; 
const images = [
  { src: logo },
  { src: logo1 },
  { src: logo2 },
  { src: logo3 },
  { src: logo4}
];

const App = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,  // Smooth fade transitions for images
    arrows: true, // Show arrows for next/prev
    adaptiveHeight: true,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // 3 seconds for each slide
    prevArrow: <div className="slick-prev"></div>, // Custom prev arrow
    nextArrow: <div className="slick-next"></div>, // Custom next arrow
  };

  return (
    <div className="carousel-container">
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index} className="carousel-item">
            <img src={image.src} alt={`slide-${index}`} className="carousel-image" />
            <div className="carousel-text"></div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default App;
